import React, { useId } from 'react';
import classNames from 'classnames';

type RadioButtonProps = {
  disabled?: boolean;
  required: boolean;
  value: string;
  name: string;
  modelValue: string;
  dataId: string;
  label: string;
  className: string;
  onChange: (data: string) => void;
  onError: (data: React.InvalidEvent) => void;
  changeButtonsGrid: boolean;
};

const RadioButton = ({
  disabled = false,
  name,
  modelValue,
  value,
  required,
  dataId,
  label,
  className,
  onChange,
  onError,
  changeButtonsGrid,
}: RadioButtonProps) => {
  const isChecked: boolean = modelValue === value;
  const id = useId();

  const setState = (): void => {
    onChange(value);
  };

  const setError = (event: React.FormEvent<HTMLInputElement>): void => {
    event.preventDefault();
    onError(event as React.InvalidEvent<HTMLInputElement>);
  };

  const radioButtonClassNames = classNames({
    'radio-button d-flex': true,
    selected: isChecked,
    disabled: disabled,
  });

  return (
    <div
      className={`d-flex align-items-start radio-button-wrapper ${className} ${
        changeButtonsGrid ? 'me-2' : ''
      }`}
    >
      <div
        className="d-inline-flex align-items-start"
        tabIndex={0}
        onClick={() => !disabled && setState()}
        onKeyDown={(e) => {
          if (e.code === 'Enter' && !disabled) {
            setState();
          }
        }}
      >
        <div className={radioButtonClassNames}>
          <input
            type="radio"
            aria-label={`radio-button ${value}`}
            data-id={dataId}
            id={id}
            required={required}
            checked={isChecked}
            onChange={() => {}}
            value={value}
            name={name}
            tabIndex={-1}
            onInvalid={setError}
          />
          {isChecked && <div className="d-flex fill-circle" />}
        </div>
      </div>
      <label className="label-slot radio-button--label ms-3">{label}</label>
    </div>
  );
};

export default RadioButton;
